// extracted by mini-css-extract-plugin
export default {"main":"TopEntityRatingBox_main__J119G","show-more":"TopEntityRatingBox_show-more__qsSFx","list":"TopEntityRatingBox_list__4Wr79"};